import { render, staticRenderFns } from "./homeChat.vue?vue&type=template&id=689730da&scoped=true&"
import script from "./homeChat.vue?vue&type=script&lang=js&"
export * from "./homeChat.vue?vue&type=script&lang=js&"
import style0 from "./homeChat.vue?vue&type=style&index=0&id=689730da&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689730da",
  null
  
)

export default component.exports